/* globals Class, $H, lp, jui */
var jQuery = require('jquery');
var ubBanzai = require('ub/control/banzai-features');
var skipPanelSyncUIOnSetElement = ubBanzai.features.isSkipPanelSyncUIOnSetElementEnabled();

var rxUi = window.rxUi;

lp.editor.panel = lp.editor.panel || {};
lp.editor.panel.ElementPropertiesPanel = Class.create(jui.Component, {
  options: function($super,options){
    return $super($H({attributes:{className:'element-properties-panel'}}).merge(options));
  },

  initialize: function($super, options) {
    this.routingKey = this.routingKey || ['ElementProperties', this.type];
    this._uiBinding = new rxUi.Binding(this.routingKey);

    this.controls = {};
    this.modelChangeHandlers = [];
    this.active = false;
    this.updatingModel = false;
    this.advancedPanel = new jui.CollapsiblePanel({title:'Element Metadata', attributes: {className:'collapsible-panel element-metadata-panel'}});
    this.advancedDefaultContent = this.advancedPanel.insert(new jui.Component());
    $super(options);
    this.advancedPanel = this.insert(this.advancedPanel);
  },

  installUI: function($super) {
    $super();
    this.title = this._insert(new Element('h1'));
    this.content = this._insert(new jui.Component({attributes:{className:'content options-panel-content'}}));
  },

  insert: function(c){
    return this.content.insert(c);
  },

  attributeChanged: function(e) {
    if (this.updatingModel) {
      return;
    }

    this.modelChangeHandlers.each(function(h) {h(e);});

    if (e.data.accessor === 'geometry.visible') {
      this.handleDisablePanel();
    } else if (e.data.accessor === 'geometry.zIndex') {
      this.syncAdvancedPanel();
    }
  },

  isDisabled: function() {
    if(this.element && this.element.isVisibleOnPage) {
      return !this.element.isVisibleOnPage();
    }
    return false;
  },

  syncUIControls: function() {
    this.syncTitlePanel();
    this.syncAdvancedPanel();
  },

  handleDisablePanel: function() {
    this.disablePanelOverlay = this.disablePanelOverlay || this._insert(new jui.Component({
      attributes:{
        className:'disable-panel-overlay'
      }
    }));


    var _adjustForVisibilityMsg = function(el) {
      var toggleMsg = jQuery('.visibility-toggle-message');
      if(toggleMsg.length > 0) {
        jQuery(el).toggleClass('msg', !toggleMsg.hasClass('closed'));
      }
    };

    var _adjustOverflowOfContentPanel = function(el, value) {
      jQuery(el).children('.content').css('overflow-y', value);
    };

    if(this.isDisabled()) {
      this.disablePanelOverlay.show();
      _adjustForVisibilityMsg(this.disablePanelOverlay.e);
      _adjustOverflowOfContentPanel(this.e, 'hidden');
    } else {
      this.disablePanelOverlay.hide();
      _adjustOverflowOfContentPanel(this.e, 'visible');
    }
  },

  syncTitlePanel: function() {
    var typeClass = this.element.type;
    var actionType = this.element.model.safeGet('action.type');

    if ((typeClass === 'lp-pom-button') &&
      (actionType === 'externalLightbox' || actionType === 'internalLightbox' ) ) {
      typeClass = 'lp-pom-lightbox-button';
    }

    var breakpoint = window.editor.page ? window.editor.page.getCurrentBreakpoint().name
        : 'desktop';

    var svgIcons = {
      'lp-pom-block':'svg-ico-page-section',
      'lp-pom-box':'svg-ico-box',
      'lp-pom-text':'svg-ico-text',
      'lp-pom-image':'svg-ico-image',
      'lp-pom-button':'svg-ico-button',
      'lp-pom-lightbox':'svg-ico-lightbox',
      'lp-pom-lightbox-button':'svg-ico-lightbox',
      'lp-pom-form':'svg-ico-form',
      'lp-pom-video':'svg-ico-video',
      'lp-pom-code':'svg-ico-html',
      'lp-code':'svg-ico-html',
      'lp-pom-social-widget':'svg-ico-social',
      'lp-pom-root': 'svg-ico-' + breakpoint
    };

    var iconClass = svgIcons[typeClass];

    if(typeof iconClass === "undefined"){
      iconClass = "";
    }

    this.title.className = typeClass + ' options-panel-title ' + iconClass;

    this.title.update(
      new Element('span', {className: 'page-name ellipsis'})
        .update(this.element.name)
    );
  },

  syncAdvancedPanel: function() {
    // TODO: get rid of string interpolation in favour of something simpler
    var pattern = '<div class="form-elm form-elm-inline-label"><label class="form-elm-mini-label form-elm-multiple-label-width">#{label}</label><input type="text" class="small form-elm-input form-elm-input-text form-elm-with-label form-elm-input-disabled" value="#{value}" readonly="readonly" /></div>';
    var zIndex = this.element.model.getZIndex();

    this.advancedDefaultContent.update(
      pattern.interpolate({label:'ID:', value: '#' + this.element.id}) +
      pattern.interpolate({label:'Class:', value: '.' + this.element.type}) +
      (this.element.parentElement && window.editor.admin ?
        pattern.interpolate({
          label: 'Parent:',
          value: this.element.parentElement.name+': '+this.element.parentElement.id
          }) :
        '') +
      (zIndex ? pattern.interpolate({label:'Z-Index:', value: zIndex}) : '')
    );
  },

  setElement: function(element) {
    this.removeAttributeChangedListener();
    this.removePageUpdatedAndRefreshedListener();
    this.element = element;
    this.addAttributeChangedListener();
    this.addPageUpdatedAndRefreshedListener();

    if ( ! skipPanelSyncUIOnSetElement) {
      if (this.parent !== null){
        this.syncUIControls(element);
      }
    }

  },

  //breakpointChanged

  removeAttributeChangedListener: function() {
    if (this.element && this.element.model) {
      this.element.model.removeListener('attributeChanged', this);
    }
  },

  addAttributeChangedListener: function() {
    if (this.element.model){
      this.element.model.addListener('attributeChanged', this);
    }
  },

  removePageUpdatedAndRefreshedListener: function() {
    if (this.element) {
      this.element.page.removeListener('pageUpdatedAndRefreshed', this);
    }
  },

  addPageUpdatedAndRefreshedListener: function() {
    if (this.element) {
      this.element.page.addListener('pageUpdatedAndRefreshed', this);
    }
  },

  pageUpdatedAndRefreshed: function(){
    if (this.parent !== null || this.type === 'lp-pom-root') {
      this.syncUIControls(this.element);
    }
  },

  requestFocus: function(e){
    window.editor.keyController.requestFocus(e.data, this);
  },

  activate: function() {
    this.active = true;
    var elm = window.editor.activeElement;
    if (elm.type === this.type && this.element !== elm) {
      this.setElement(elm);
    }

    if(this.isCurrentElementSyncable()) {
      this.syncUIControls(this.element);
    }

    this.handleDisablePanel();

    this.fireEvent('activated');
  },

  isCurrentElementSyncable: function() {
    return !!this.element.model;
  },

  deactivate: function() {
    this.active = false;
    this.fireEvent('deactivated');
  },

  performModelUpdates: function(updates) {
    this.updatingModel = true;
    updates();
    this.updatingModel = false;
  }
});



//////////////////
// WEBPACK FOOTER
// ./src/legacy/lp/editor/panel/element_properties_panel.js
// module id = 1034
// module chunks = 0